import { render, staticRenderFns } from "./proRec.vue?vue&type=template&id=3d94014b&scoped=true&"
import script from "./proRec.vue?vue&type=script&lang=js&"
export * from "./proRec.vue?vue&type=script&lang=js&"
import style0 from "./proRec.vue?vue&type=style&index=0&id=3d94014b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d94014b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Ware: require('/app/components/ware-view/ware.vue').default})
